import React from 'react'
import BodyText from './text/BodyText'

const FontPreload = () => <BodyText style={{ opacity: 0 }}>Text preload</BodyText>

export default FontPreload
